"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Layout = void 0;

var _react = _interopRequireDefault(require("react"));

var _Header = _interopRequireDefault(require("../Header"));

var _NavMenuDivider = _interopRequireDefault(require("../../../NavMenuDivider"));

var _Content = require("./Content");

var Layout = function Layout(_ref) {
  var currentProduct = _ref.currentProduct,
      environment = _ref.environment,
      features = _ref.features,
      inverted = _ref.inverted,
      onLinkClick = _ref.onLinkClick,
      onReloadHandler = _ref.onReloadHandler,
      swicusOrgId = _ref.swicusOrgId,
      onShowFeedbackModal = _ref.onShowFeedbackModal;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    inverted: inverted
  }), /*#__PURE__*/_react["default"].createElement(_NavMenuDivider["default"], null), /*#__PURE__*/_react["default"].createElement(_Content.Content, {
    currentProduct: currentProduct,
    environment: environment,
    features: features,
    inverted: inverted,
    onLinkClick: onLinkClick,
    onReloadHandler: onReloadHandler,
    swicusOrgId: swicusOrgId,
    onShowFeedbackModal: onShowFeedbackModal
  }));
};

exports.Layout = Layout;